import KioskInactivityWarning from './KioskInactivityWarning';

export default KioskInactivityWarning;


// WEBPACK FOOTER //
// ./src/components/KioskInactivityWarning/index.jsx